import React from 'react';
import * as constant from './constants';
import Button from './../Button';
import ImageButton from './../Button/ImageButton';
import FormGroup from './../FormGroup';
import Keyboard from './../Keyboard/Keyboard';
import Asset from "../../requests/apa/Asset";
import Translator from '../../requests/apa/Translator';
import UtilsProfile from '../../utils/Profile';
const quantity = 8; //8 Elementos por página
const withoutOpacity = '1'; 
const withOpacity = '0.5';

export const Select = ({ props }) => {

  const opacity = props.selectedImage === '' ? withOpacity : withoutOpacity;

  const style = {
    opacity
  }

  UtilsProfile.setFocus(
    props && props.selectedImage
      ? '.container.select_profile .row.buttons .button:nth-of-type(2)'
      : '.container.select_profile .row.avatar .focusable'
  );

  return (
    <div className='container select_profile'>
      <div className='row'>
      </div>
      <div className='row title'>
        <span>{Translator.get('select_picture_profile_title', 'Selecciona la imagen de tu perfil')}</span>
      </div>
      <div className='row avatar'>
        <div className='container'>{getAvatars(props.items, props.currentPage, props.selectedImage, props.setSelectedImage)}</div>        
      </div>
      <div className='row buttons'>
        <Button order={['text']} className='button' text={Translator.get('select_picture_profile_cancel_btn', 'Cancelar')}
          onClick={() => {            
            props.onSetAction(props.formFrom)            
          }} />
        <Button order={['text']} className='button' text={Translator.get('select_picture_profile_ok_btn', 'Aceptar')}
          focusable={props.selectedImage !== ''}
          style={style}
          onClick={() => {            
            props.onSetAction(props.formFrom);
            props.sendMetricProfile({
              event: constant.METRIC_EVENT,
              category: constant.METRIC_CATEGORY_START,
              action: constant.METRIC_ACTION_PROFILE,
              label: constant.METRIC_LABEL_SELECTIMAGE,
            });
            props.setImageValue(props.selectedImage);            
          }} />
      </div>
      <div>
        {props.currentPage > 1 &&
        <Button
          className="page-left"
          text=''
          iconClassName={"fa fa-chevron-left"}          
          onClick={() => {            
            props.updateCurrentPage(-1);            
          }}
        />
        }
        {props.currentPage < getTotalPages(props.items.length) &&
        <Button
          className="page-right"
          text=''
          iconClassName={"fa fa-chevron-right"}          
          onClick={() => {            
            props.updateCurrentPage(1);            
          }}
        />
        }
      </div>
    </div>
  );
};

const getAvatars = (items, currentPage, selectedImage, callback) => {
  if (items && items.length) {

    const begin = (quantity * currentPage) - quantity;
    const end = (quantity * currentPage) - 1;

    const PageItems = items.filter((currentValue, index) => {
      return index >= begin && index <= end
    });

    return PageItems.map((item, index) => {
      const imgSrc = item.user_image;

      const opacity = selectedImage === '' ? withoutOpacity : selectedImage == item.user_image ? withoutOpacity : withOpacity;

      const style = {
        opacity
      }

      return <ImageButton imgId={item.id} order={['text']} className='button' imgSrc={`${imgSrc}-${index}`}
        style={style}
        onClick={(e) => {          
          markSelected(item, callback)          
        }}
        onBlur={(item) => console.log('onBlur')}
      />
    });
  }
  else {
    return null;
  }
}

const markSelected = (item, callback) => {

  const id = item.id;
  const links = document.querySelectorAll(".row.avatar .container > a");
 

  for (var i = 0; i < links.length; i++) {    
    const link = links[i];
    if (link.childNodes[0].id == id) {
      callback(item.user_image);
    }
  }

}

const getTotalPages = (total) => Math.ceil(total / quantity);



// WEBPACK FOOTER //
// ./src/components/Profile/Select.jsx